import React from "react";
import { Link } from "react-router-dom";
import "./RightElements.css";

const FooterElements = () => (
  <div className="footer-elements">
    <div className="footer-links-row">
      <Link to="/about">Despre</Link>
      <Link to="/check-certification">Certificari</Link>
       <Link to="/feedback">Feedback</Link>
      <Link to="/blog">Blog</Link>
      <Link to="/FAQ">Intrebari</Link>
      <Link to="/politica">Confidentialitate</Link>
      <Link to="/ajutor">Ajutor</Link>
      
    </div>
  </div>
);

export default FooterElements;
